<template>
  <div class="item-box">
    <a :href="linkUrl" @click="onClickLink">
      <div class="item-card">
        <div class="item-card-icon">
          <img :src="imageUrl" />
        </div>
        <div class="item-card-info">
          <div class="item-card__brand-name">
            {{ brandName }}
          </div>
          <div class="item-card__item-name">
            {{ itemName }}
          </div>
          <div class="item-card__item-sku-name">
            <span v-if="hasMultipleItemSkus">
              {{ itemSkuName }}
            </span>
          </div>
          <div class="item-card__item-prices">
            <span class="item-card__item-price">{{ itemSkuPrice }}</span>
            <span v-if="isIncludingTax" class="item-card__item-tax">税込</span>
          </div>
        </div>
        <div v-if="showAddButton" class="add-button-box">
          <button class="text-link add-button" @click="onClickAddButton">
            <span class="tl-plus-circle--left">
              追加する
            </span>
          </button>
        </div>
      </div>
    </a>
  </div>
</template>
<script>
export default {
  props: {
    linkUrl: {
      type: String,
      required: true
    },
    imageUrl: {
      type: String,
      required: true
    },
    brandName: {
      type: String,
      required: true
    },
    itemName: {
      type: String,
      required: true
    },
    itemSkuName: {
      type: String,
      required: false,
      default: ''
    },
    itemSkuPrice: {
      type: String,
      required: true
    },
    isIncludingTax: {
      type: Boolean,
      required: true
    },
    hasMultipleItemSkus: {
      type: Boolean,
      required: true
    },
    showAddButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    onClickAddButton() {
      this.$emit('clicked-add-button')
    },
    onClickLink() {
      this.$emit('clicked-link')
    }
  }
}
</script>
<style lang="scss" scoped>
.item-box {
  width: 160px;
  flex-shrink: 0;

  a:hover {
    text-decoration: none;
  }
}

.item-card {
  @extend %hover-common;
  background-color: $white;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  text-decoration: none;
  border: 1px solid $gray-2;
  box-sizing: border-box;

  &-icon {
    // NOTE: inline-block 要素間の空白や改行などにあたる暗黙的なスタイルを回避するための対応
    font-size: 0;

    img {
      width: 100%;
      height: 100%;
    }
  }

  &-info {
    padding: 8px;
    background-color: $white;
    text-align: left;
  }

  &__brand-name {
    color: $gray-1;
    font-size: 1.2rem;
    line-height: 1.6;
    padding: 8px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__item-name {
    color: $black;
    white-space: normal;
    overflow-wrap: break-word;
    line-height: 1.6;
    font-size: 1.4rem;
    height: 44px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  &__item-sku-name {
    color: $black;
    font-size: 1.2rem;
    line-height: 1.6;
    padding: 8px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    box-sizing: content-box;
    // NOTE: sku名がない場合も高さを保つため、heightを指定する。
    height: calc(1.2rem * 1.6);
  }

  &__item-prices {
    padding-top: 0px;
  }

  &__item-price {
    font-weight: bold;
    font-size: 1.6rem;
    line-height: 1.5;
    color: $black;
  }

  &__item-tax {
    line-height: 1.6;
    font-size: 0.8rem;
    color: $black;
  }
}

.add-button-box {
  padding: 0 8px 16px 8px;
}
</style>
